import { Service } 						from "./../../Libs/Service";

import { Server } 						from "./Server";

let User = new Service({

	Name: "User",

	Libraries: [],

	Events: {

	},

	Actions: {

		//Получение текущего пользователя
		'User': function(user) {

			this.User = user;

			this.isCurentUserAdmin = user ? user.IsAdmin : false;

			if (user) this.setUser(user);

			//Помечаем что текущий пользователь загружен (даже если user === null, это означает что пользователь не авторизован и об этом теперь будет известно на клиенте)
			this.loaded = true;

			Broadcast.call("Current User Changed", [user]);

		},

		//Получение данных других пользователей
		"Users": function(users) {

			this.setUsers(users);

		}

	},

	init() {

		//Текущий пользователь
		this.User = null;

		//Данные всех пользователей переданных с сервера (хэш по id пользователя)
		this.Users = {};

	},

	setUser(user) {

		this.Users[user.id] = user;

		Broadcast.call("User Changed", [user.id]);

	},

	setUsers(users) {

	_.each(users, user => {
		this.Users[user.id] = user;
	});

	},

	updateUsersCache() {

		Server.sendToSocket({
			UpdateUsersCache: true
		});

	},

	logout() {

		Server.sendToSocket({
			Logout: true
		});

	}

});

//Делаем глобальную ссылку для дебага - чтобы в консоли был виден этот объект сразу
window.User = User;

export { User }

